import React, { useEffect, useState } from 'react';
import { FaRegEdit, FaRegTrashAlt, FaSearch } from "react-icons/fa";
import { Modal, Label, TextInput, Checkbox, Button, Table, Select } from 'flowbite-react';
import { toast } from 'react-toastify'; // assuming you're using react-toastify for notifications
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function CustomerDetail() {

    // user token for API request
    const token = JSON.parse(window.localStorage.getItem("auth"))?.token;

    // userDatail  for API request
    const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;

    const [existingCustomers, setExistingCustomers] = useState([]);
    const [newCustomerData, setNewCustomerData] = useState({});
    const [customerCreateModal, setCustomerCreateModal] = useState(false);
    const [customerEditModal, setCustomerEditModal] = useState(false);
    const [existingEditCustomer, setExistingEditCustomer] = useState({});
    const [updatedCustomerData, setUpdatedCustomerData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [searchModal, setSearchModal] = useState(false);
    const [isSearching, setIsSearching] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (userDetail && userDetail.userRole !== 'Admin') {
            navigate('/buying-currency');
        }
    }, [])

    useEffect(() => {
        if (userDetail && userDetail.userRole === 'Admin' && userDetail.shopId === undefined) {
            navigate('/shopSelection');
        }
    }, [])

    const fetchCustomer = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + `getShopCustomers`, {
                params: {
                    shopId: userDetail?.shopId
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const customers = response.data;
            // rates.AUD = 1;
            setExistingCustomers(customers);

            // console.log('shops:', existingShops)
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchCustomer();
    }, [])

    const createNewCustomer = async () => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}saveCustomerData`, newCustomerData,
                {
                    params: {
                        shopId: userDetail?.shopId,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 201) {
                setCustomerCreateModal(val => !val)
                toast.success("Customer Created Successfully");
            }
            fetchCustomer();
            setIsLoading(false)

            if (response.status === 200) {
                setCustomerCreateModal(val => !val)
                // Clear form fields
                setNewCustomerData({});

                toast.success('Success: Customer Information Saved');
                fetchCustomer();
                setIsLoading(false)
            } else {
                toast.error(response.data.message || 'Something went wrong.');
                setIsLoading(false)
            }
        } catch (error) {
            setIsLoading(false)
            const errorMessage = error.response?.data?.message || 'Server error occurred.';
            toast.error(errorMessage);
            console.error('Error saving customer:', error);
        }
    }

    const handleEditCustomer = async (existingCustomer) => {
        setExistingEditCustomer(existingCustomer);
        setCustomerEditModal(val => !val)
    }

    const updateCustomer = async (id) => {
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL + `updateCustomerInfo`, {
                userId: id,
                ...updatedCustomerData
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.status === 201) {
                setCustomerEditModal(val => !val)
                toast.success('Customer Updated Successfully.');
            }
            fetchCustomer();
        } catch (error) {
            toast.error('Error: Customer Not Updated.');
        }
    }

    const handleDeleteCustomer = async (id) => {
        try {
            // Show confirmation toast with styled buttons
            const confirmDelete = await new Promise((resolve) => {
                toast(
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center', // Ensure vertical centering
                        textAlign: 'center', // Center the text
                        padding: '20px', // Add some padding around the content
                    }}>
                        <FaRegTrashAlt size={30} style={{
                            marginBottom: '10px',
                            color: '#FF6347'
                        }} />
                        <span style={{
                            fontSize: '16px',
                            fontWeight: '500',
                            marginBottom: '20px',
                            color: '#333'  // Adjust text color for better readability
                        }}>
                            Are you sure you want to delete this Customer?
                        </span>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            {/* Yes Button */}
                            <button
                                onClick={() => {
                                    resolve(true);  // Resolve with true when Yes is clicked
                                    toast.dismiss(); // Close the toast
                                }}
                                style={{
                                    backgroundColor: '#05407F', // Red for Yes
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s',
                                }}
                            >
                                Yes, Delete
                            </button>

                            {/* No Button */}
                            <button
                                onClick={() => {
                                    resolve(false);  // Resolve with false when No is clicked
                                    toast.dismiss(); // Close the toast
                                }}
                                style={{
                                    backgroundColor: '#ccc', // Gray for No
                                    color: 'black',
                                    border: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s',
                                }}
                            >
                                No, Keep
                            </button>
                        </div>
                    </div>,
                    {
                        position: "top-center",
                        autoClose: false,  // Prevent auto close
                        hideProgressBar: true,  // Hide progress bar
                        closeOnClick: false,  // Prevent clicking outside to close
                        className: 'delete-toast',  // Optionally add custom class for styling
                    }
                );
            });

            if (confirmDelete) {
                // Proceed with deletion if the user confirms
                const response = await axios.post(
                    process.env.REACT_APP_API_URL + `deleteCustomer`,  // API URL for deletion
                    { userId: id },  // Send Customer ID in the request body
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,  // Authorization header
                        },
                    }
                );

                // Handle the response
                if (response.status === 200) {
                    toast.success('Customer Deleted Successfully.');
                    fetchCustomer();  // Fetch updated Employee list
                }
            } else {
                toast.info('Customer deletion was canceled.');  // Inform the user if canceled
            }

        } catch (error) {
            toast.error('Error: Customer Not Deleted.');  // Show error if something goes wrong
        }
    };

    const handleSearch = async () => {
        if (!searchQuery.trim()) {
            toast.warning('Please enter a phone number to search');
            return;
        }

        setIsSearching(true);
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + `getShopCustomerbyPhoneNumber`, {
                params: {
                    shopId: userDetail?.shopId,
                    phoneNumber: searchQuery
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.status == 200 && response.data.length !== 0) {
                setSearchResults(response.data);
                setSearchModal(true);
            } else {
                toast.info('No customer found with this phone number');
            }
        } catch (error) {
            // console.error('Search error:', error);
            toast.error('Error searching for customer');
        } finally {
            setIsSearching(false);
        }
    };

    return (
        <div className="container mx-auto p-5 space-y-10 flex flex-col">
            <div className="">
                <div className="">
                    {/* <h1 className="text-headings text-3xl font-medium mt-10">Foreign Currency Balance</h1> */}
                </div>
                <div className="flex justify-between mb-4">
                    <h1 className="text-headings text-3xl font-medium ">Customers</h1>
                    {/* Search Bar */}
                    <div className="w-[300px] mb-6 flex items-center ">
                        <div className="relative flex-1">
                            <TextInput
                                type="text"
                                placeholder="Search by phone number..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="w-full"
                            />
                            <button
                                onClick={handleSearch}
                                disabled={isSearching}
                                className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-theme-secondary text-white p-2 rounded hover:bg-theme-primary transition-colors"
                            >
                                <FaSearch />
                            </button>
                        </div>
                    </div>
                    <Button className="w-52 h-11 bg-theme-secondary" onClick={() => setCustomerCreateModal(val => !val)}>Add Customer</Button>
                </div>

                <div className="h-[400px] overflow-x-auto bg-gray-50 dark:bg-gray-900 rounded-lg shadow-md">
                    {existingCustomers && existingCustomers.length > 0 ? (
                        <div>
                            <Table className="h-[500px]">
                                <Table.Head className="sticky top-0 z-10 bg-theme-secondary">
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>#</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>Name</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>Phone</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>Email</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>Id Type</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>Id Issuer</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>Id Number</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>Id Issue Date</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>Id Expiry Date</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>Date of Birth</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>Address</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>Occupation</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-sm '>Action</Table.HeadCell>
                                </Table.Head>
                                <Table.Body className="divide-y">
                                    {existingCustomers && (existingCustomers.map((existingCustomer, index) => (
                                        <Table.Row key={index} className="bg-slate-200  dark:border-gray-700 dark:bg-gray-800  ">
                                            <Table.Cell className="font-semibold text-sm text-center ">{index + 1}</Table.Cell>
                                            <Table.Cell className="font-semibold text-sm text-center ">{existingCustomer.name}</Table.Cell>
                                            <Table.Cell className="font-semibold text-sm text-center ">{existingCustomer.phoneNumber}</Table.Cell>
                                            <Table.Cell className="font-semibold text-sm text-center ">{existingCustomer.email ? existingCustomer.email : <span className='text-xs text-red-500 text-center'>Not Given</span>}</Table.Cell>
                                            <Table.Cell className="font-semibold text-sm text-center ">{existingCustomer.idType ? existingCustomer.idType : <span className='text-xs text-red-500 text-center'>Not Given</span>}</Table.Cell>
                                            <Table.Cell className="font-semibold text-sm text-center ">{existingCustomer.idIssuer ? existingCustomer.idIssuer : <span className='text-xs text-red-500 text-center'>Not Given</span>}</Table.Cell>
                                            <Table.Cell className="font-semibold text-sm text-center ">{existingCustomer.idNumber ? existingCustomer.idNumber : <span className='text-xs text-red-500 text-center'>Not Given</span>}</Table.Cell>
                                            <Table.Cell className="font-semibold text-sm text-center ">{existingCustomer.idIssueDate ? existingCustomer.idIssueDate : <span className='text-xs text-red-500 text-center'>Not Given</span>}</Table.Cell>
                                            <Table.Cell className="font-semibold text-sm text-center ">{existingCustomer.idExpiryDate ? existingCustomer.idExpiryDate : <span className='text-xs text-red-500 text-center'>Not Given</span>}</Table.Cell>
                                            <Table.Cell className="font-semibold text-sm text-center ">{existingCustomer.dob ? existingCustomer.dob : <span className='text-xs text-red-500 text-center'>Not Given</span>}</Table.Cell>
                                            <Table.Cell className="font-semibold text-sm text-center ">{existingCustomer.address ? existingCustomer.address : <span className='text-xs text-red-500 text-center'>Not Given</span>}</Table.Cell>
                                            <Table.Cell className="font-semibold text-sm text-center ">{existingCustomer.occupation ? existingCustomer.occupation : <span className='text-xs text-red-500 text-center'>Not Given</span>}</Table.Cell>
                                            <Table.Cell className="font-semibold text-sm text-center ">
                                                <button className={`border-0 w-7 rounded p-1 bg-#ff7675 text-green-500 hover:text-white hover:font-bold hover:bg-green-500`} onClick={() => handleEditCustomer(existingCustomer)} ><FaRegEdit className={``} /></button>
                                                <button className={`border-0 w-7 ml-1 rounded p-1 bg-#ff7675 text-red-500 hover:text-white hover:font-bold hover:bg-red-500`} onClick={() => handleDeleteCustomer(existingCustomer._id)} ><FaRegTrashAlt className={``} /></button>
                                            </Table.Cell>
                                        </Table.Row>
                                    )))}
                                </Table.Body>
                            </Table>
                        </div>
                    ) : (
                        <div>
                            <div>
                                <h1 className='text-[2rem] text-center mt-10 text-black'>Nothing to Show</h1>
                            </div>
                        </div>
                    )}

                </div>

                {/* Flowbite Modal for Create Customer */}
                <Modal dismissible size='lg' show={customerCreateModal} onClose={() => setCustomerCreateModal(false)} setNewCustomerData={setNewCustomerData} createNewCustomer={createNewCustomer} >
                    <Modal.Header>Add New Customer</Modal.Header>
                    <Modal.Body>
                        <div className="flex max-w-md flex-col gap-3 mx-auto" >
                            <div className="mb-1">
                                <h2 className="text-center text-[#063A73] font-bold text-[2rem]">Customer Details</h2>
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="Name" value="Name" />
                                </div>
                                <TextInput
                                    name="customerName"
                                    type="text"
                                    placeholder="Enter Customer Name"
                                    // value={name}
                                    onChange={(e) => setNewCustomerData({
                                        ...newCustomerData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="phoneNumber" value="Phone Number" />
                                </div>
                                <TextInput
                                    name="phoneNumber"
                                    type="text"
                                    placeholder="Enter Customer Phone Number"
                                    // value={name}
                                    onChange={(e) => setNewCustomerData({
                                        ...newCustomerData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="email" value="Email (Optional)" />
                                </div>
                                <TextInput
                                    name="customerEmail"
                                    type="email"
                                    placeholder="Enter Customer Email"
                                    // value={email}
                                    onChange={(e) => setNewCustomerData({
                                        ...newCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="idType" value="Id Type (Optional)" />
                                </div>
                                <TextInput
                                    name="idType"
                                    type="text"
                                    placeholder="Enter Id Type"
                                    // value={email}
                                    onChange={(e) => setNewCustomerData({
                                        ...newCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="idIssuer" value="Id Issuer (Optional)" />
                                </div>
                                <TextInput
                                    name="idIssuer"
                                    type="text"
                                    placeholder="Enter Id Issuer"
                                    // value={email}
                                    onChange={(e) => setNewCustomerData({
                                        ...newCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="idNumber" value="Id Number (Optional)" />
                                </div>
                                <TextInput
                                    name="idNumber"
                                    type="text"
                                    placeholder="Enter Id Number"
                                    // value={email}
                                    onChange={(e) => setNewCustomerData({
                                        ...newCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="idIssueDate" value="Id Issue Date (Optional)" />
                                </div>
                                <TextInput
                                    name="idIssueDate"
                                    type="date"
                                    placeholder="Enter Id Issue Date"
                                    // value={email}
                                    onChange={(e) => setNewCustomerData({
                                        ...newCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="idExpiryDate" value="Id Expiry Date (Optional)" />
                                </div>
                                <TextInput
                                    name="idExpiryDate"
                                    type="date"
                                    placeholder="Enter Id Expiry Date"
                                    // value={email}
                                    onChange={(e) => setNewCustomerData({
                                        ...newCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="dob" value="Date of Birth (Optional)" />
                                </div>
                                <TextInput
                                    name="dob"
                                    type="date"
                                    placeholder="Enter Date of Birth"
                                    // value={email}
                                    onChange={(e) => setNewCustomerData({
                                        ...newCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="address" value="Address (Optional)" />
                                </div>
                                <TextInput
                                    name="address"
                                    type="text"
                                    placeholder="Enter Address"
                                    // value={email}
                                    onChange={(e) => setNewCustomerData({
                                        ...newCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="occupation" value="Occupation (Optional)" />
                                </div>
                                <TextInput
                                    name="occupation"
                                    type="text"
                                    placeholder="Enter Occupation"
                                    // value={email}
                                    onChange={(e) => setNewCustomerData({
                                        ...newCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>

                            <button onClick={createNewCustomer}
                                disabled={!newCustomerData.customerName || !newCustomerData.phoneNumber}
                                className="bg-gradient-to-br from-theme-primary to-theme-secondary text-white py-2 rounded-lg">

                                Add Customer
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* Flowbite Modal for Edit Customer */}
                <Modal dismissible size='lg' show={customerEditModal} onClose={() => setCustomerEditModal(false)} existingEditCustomer={existingEditCustomer} setUpdatedCustomerData={setUpdatedCustomerData} updateCustomer={updateCustomer} >
                    <Modal.Header>Edit Customer Info</Modal.Header>
                    <Modal.Body>
                        <div className="flex max-w-md flex-col gap-3 mx-auto" >
                            <div className="mb-1">
                                <h2 className="text-center text-[#063A73] font-bold text-[2rem]">Edit Customer</h2>
                            </div>


                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="Name" value="Name" />
                                </div>
                                <TextInput
                                    name="customerName"
                                    type="text"
                                    placeholder="Enter Customer Name"
                                    defaultValue={existingEditCustomer.name}
                                    onChange={(e) => setUpdatedCustomerData({
                                        ...updatedCustomerData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="phoneNumber" value="Phone Number" />
                                </div>
                                <TextInput
                                    name="phoneNumber"
                                    type="text"
                                    placeholder="Enter Customer Phone Number"
                                    defaultValue={existingEditCustomer.phoneNumber}
                                    onChange={(e) => setUpdatedCustomerData({
                                        ...updatedCustomerData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="email" value="Email (Optional)" />
                                </div>
                                <TextInput
                                    name="customerEmail"
                                    type="email"
                                    placeholder="Enter Customer Email"
                                    defaultValue={existingEditCustomer.email}
                                    onChange={(e) => setUpdatedCustomerData({
                                        ...updatedCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="idType" value="Id Type (Optional)" />
                                </div>
                                <TextInput
                                    name="idType"
                                    type="text"
                                    placeholder="Enter Id Type"
                                    defaultValue={existingEditCustomer.idType}
                                    onChange={(e) => setUpdatedCustomerData({
                                        ...updatedCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="idIssuer" value="Id Issuer (Optional)" />
                                </div>
                                <TextInput
                                    name="idIssuer"
                                    type="text"
                                    placeholder="Enter Id Issuer"
                                    defaultValue={existingEditCustomer.idIssuer}
                                    onChange={(e) => setUpdatedCustomerData({
                                        ...updatedCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="idNumber" value="Id Number (Optional)" />
                                </div>
                                <TextInput
                                    name="idNumber"
                                    type="text"
                                    placeholder="Enter Id Number"
                                    defaultValue={existingEditCustomer.idNumber}
                                    onChange={(e) => setUpdatedCustomerData({
                                        ...updatedCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="idIssueDate" value="Id Issue Date (Optional)" />
                                </div>
                                <TextInput
                                    name="idIssueDate"
                                    type="date"
                                    placeholder="Enter Id Issue Date"
                                    defaultValue={existingEditCustomer.idIssueDate}
                                    onChange={(e) => setUpdatedCustomerData({
                                        ...updatedCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="idExpiryDate" value="Id Expiry Date (Optional)" />
                                </div>
                                <TextInput
                                    name="idExpiryDate"
                                    type="date"
                                    placeholder="Enter Id Expiry Date"
                                    defaultValue={existingEditCustomer.idExpiryDate}
                                    onChange={(e) => setUpdatedCustomerData({
                                        ...updatedCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="dob" value="Date of Birth (Optional)" />
                                </div>
                                <TextInput
                                    name="dob"
                                    type="date"
                                    placeholder="Enter Date of Birth"
                                    defaultValue={existingEditCustomer.dob}
                                    onChange={(e) => setUpdatedCustomerData({
                                        ...updatedCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="address" value="Address (Optional)" />
                                </div>
                                <TextInput
                                    name="address"
                                    type="text"
                                    placeholder="Enter Address"
                                    defaultValue={existingEditCustomer.address}
                                    onChange={(e) => setUpdatedCustomerData({
                                        ...updatedCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="occupation" value="Occupation (Optional)" />
                                </div>
                                <TextInput
                                    name="occupation"
                                    type="text"
                                    placeholder="Enter Occupation"
                                    defaultValue={existingEditCustomer.occupation}
                                    onChange={(e) => setUpdatedCustomerData({
                                        ...updatedCustomerData, [e.target.name]: e.target.value
                                    })}
                                    shadow
                                />
                            </div>

                            <button onClick={() => updateCustomer(existingEditCustomer._id)}
                                // disabled={!updatedCustomerData.customerName || !updatedCustomerData.phoneNumber}
                                className="bg-gradient-to-br from-theme-primary to-theme-secondary text-white py-2 rounded-lg">

                                Update Customer
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* Search Results Modal */}
                <Modal dismissible size='lg' show={searchModal} onClose={() => setSearchModal(false)}>
                    <Modal.Header>Search Results</Modal.Header>
                    <Modal.Body>
                        {searchResults.map((customer, index) => (
                            <div key={index} className="mb-6 p-4 border rounded-lg shadow-sm">
                                <h3 className="text-xl font-semibold mb-4 text-theme-secondary">{customer.name}</h3>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <p className="text-sm text-gray-600">Phone Number</p>
                                        <p className="font-medium">{customer.phoneNumber}</p>
                                    </div>
                                    <div>
                                        <p className="text-sm text-gray-600">Email</p>
                                        <p className="font-medium">{customer.email || 'Not provided'}</p>
                                    </div>
                                    <div>
                                        <p className="text-sm text-gray-600">ID Type</p>
                                        <p className="font-medium">{customer.idType || 'Not provided'}</p>
                                    </div>
                                    <div>
                                        <p className="text-sm text-gray-600">ID Number</p>
                                        <p className="font-medium">{customer.idNumber || 'Not provided'}</p>
                                    </div>
                                    <div>
                                        <p className="text-sm text-gray-600">Address</p>
                                        <p className="font-medium">{customer.address || 'Not provided'}</p>
                                    </div>
                                    <div>
                                        <p className="text-sm text-gray-600">Occupation</p>
                                        <p className="font-medium">{customer.occupation || 'Not provided'}</p>
                                    </div>
                                    <div>
                                        <p className="text-sm text-gray-600">Date of Birth</p>
                                        <p className="font-medium">{customer.dob || 'Not provided'}</p>
                                    </div>
                                    <div>
                                        <p className="text-sm text-gray-600">ID Issue Date</p>
                                        <p className="font-medium">{customer.idIssueDate || 'Not provided'}</p>
                                    </div>
                                    <div>
                                        <p className="text-sm text-gray-600">ID Expiry Date</p>
                                        <p className="font-medium">{customer.idExpiryDate || 'Not provided'}</p>
                                    </div>
                                </div>
                                <div className="mt-4 flex justify-end gap-2">
                                    <Button
                                        color="gray"
                                        onClick={() => {
                                            setExistingEditCustomer(customer);
                                            setCustomerEditModal(true);
                                            setSearchModal(false);
                                        }}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        color="failure"
                                        onClick={() => {
                                            handleDeleteCustomer(customer._id);
                                            setSearchModal(false);
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </Modal.Body>
                </Modal>
            </div>

        </div>
    );
}

export default CustomerDetail;

